<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1>{{ data.title }}</h1>
    </div>

    <div
      class="mt-2 w-450"
      *ngIf="data.showBody">
      <span *ngIf="!data.titleBody">{{ data.title }} using Excel file</span>
      <span *ngIf="data.titleBody">{{ data.titleBody }}</span>

      <div
        *ngIf="data.type !== UploadType.SCENARIO"
        class="upload-help">
        <span>
          <ng-container *ngIf="!uploadModalService.showGenerateTemplate">
            Download and use the following
            <a
              (click)="onGenerateTemplate()"
              target="_self">
              Generate Template </a
            >.
          </ng-container>
          Refer to
          <a
            href="{{ getInstructionUrl() }}"
            target="_blank"
            style="outline: none">
            Instruction Manual
          </a>
          for further information.
        </span>
      </div>
    </div>

    <button
      class="close-button"
      mat-dialog-close>
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>
